import { Stack } from '@mui/material';
import { FC } from 'react';
import { FaqItem } from './FaqItem';
import { useTranslation } from 'hooks/useTranslation';

interface Props {
    faqs: {
        question: string;
        answer: string;
    }[];
}

export const FaqsList: FC<Props> = ({ faqs }) => {
    const { t } = useTranslation();

    return (
        <Stack sx={{ flex: 1, gap: '24px' }}>
            {faqs.map((faq) => (
                <FaqItem key={`faq-${faq.question}`} question={t(faq.question)} answer={t(faq.answer)} />
            ))}
        </Stack>
    );
};
